import { throttle } from "../shared";
const SCROLL_OFFSET = 100;
class StickyRow {
    constructor(formEl, isExternalRegistration = false) {
        this._formEl = null;
        this._formElRect = null;
        this._isExternalRegistration = false;
        this._ctaWrapper = document.querySelector(".hora-events-single-event .event-sticky-cta");
        this._formEl = formEl;
        this._isExternalRegistration = isExternalRegistration;
        if (this._ctaWrapper) {
            this._ctaWrapperRect = this._ctaWrapper.getBoundingClientRect();
        }
        if (this._formEl) {
            this._formElRect = this._formEl.getBoundingClientRect();
        }
        this.init();
    }
    init() {
        this.bindEvents();
    }
    bindEvents() {
        if (!this._ctaWrapper) {
            return;
        }
        jQuery(window).on("scroll", throttle(this._handleScroll.bind(this), 100, {
            leading: true,
            trailing: true,
        }));
    }
    _handleScroll() {
        // if top of window is over the top of the ctaWrapper
        const isOverCtaWrapper = this._ctaWrapperRect.top < window.scrollY;
        const isFixedConditionArray = [isOverCtaWrapper];
        if (!this._isExternalRegistration && this._formElRect) {
            isFixedConditionArray.push(this._formElRect.top < window.innerHeight && this._formElRect.bottom > 0);
        }
        if (isFixedConditionArray.every(Boolean)) {
            if (!this._ctaWrapper.classList.contains("hora-fixed")) {
                this._ctaWrapper.style.opacity = "0";
                setTimeout(() => {
                    this._ctaWrapper.classList.add("hora-fixed");
                    const ctaHeight = this._ctaWrapper.offsetHeight;
                    this._ctaWrapper.style.top = `calc(100vh - ${ctaHeight}px - 20px)`;
                    this._ctaWrapper.style.opacity = "1";
                }, 300);
            }
        }
        else {
            this._ctaWrapper.classList.remove("hora-fixed");
        }
    }
}
export function initStickyRow(formEl, isExternalRegistration = false) {
    const stickyRow = new StickyRow(formEl, isExternalRegistration);
}
export { StickyRow };
